import { HTMLInputTypeAttribute, useEffect, useState } from 'react';

const usePassword = (initialType: HTMLInputTypeAttribute) => {
	const [type, setType] = useState<HTMLInputTypeAttribute>('text');

	const togglePasswordView = (): void => {
		const newType: string = type === 'text' ? 'password' : 'text';
		setType(newType);
	};

	const getIcon = (): string => {
		const isVisible: boolean = type === 'text';
		return isVisible ? 'eye-slash-fill' : 'eye-fill';
	};

	useEffect(() => {
		setType(initialType);
	}, [initialType]);

	return { type, icon: getIcon(), togglePasswordView };
};

export default usePassword;
